import CheckInDetails from '@/dossier/models/CheckInDetails';
import { parseEntity } from '@/shared/converters/commonConverters';
import { parseKeyLabel } from '@/vehicle/converters/vehicleConverters';
import { parseComplaintDiagnostic, parseWarrantyStatus } from '@/jobs/converters/jobConverters';
import { isPresent } from '@/shared/utils/typescript';
import { parseMoment } from '@/shared/converters/dateConverters';
import { parseLocation } from '@/vehicle/converters/locationConverters';

const SCHEMA = {
  dossier: {
    id: 'id',
    externalReference: 'externalReference',
    exteriorCleaningStatus: 'cleaningStatus',
    exteriorCleaningMethod: 'cleaningMethod',
    interiorCleaningStatus: 'interiorCleaningStatus',
    communicationPreference: 'communicationPreference',
    appointmentOn: (data: any) => parseMoment(data.appointment.drop),
    preferredPickUpOn: (data: any) => parseMoment(data.appointment.return),
    waitsOnPremise: 'appointment.waitsOnPremise',
  },
  vehicle: {
    isVerifiedMileage: 'object.isVerifiedMileage',
    mileage: 'object.mileage',
    location: (data: any) => parseLocation(data.object),
    registrationNumber: 'object.registrationNumber',
    odometerImage: 'object.odometerImage',
    keyLabel: (data: any) => parseKeyLabel(data),
  },
  contacts: (data: any) => {
    return data.contacts.map((contact: any) => {
      return {
        id: contact.id,
        communicationSummary: contact.communicationDetails,
      };
    });
  },
  jobs: (data: any) => {
    return data.jobs.map((job: any) => {
      return {
        id: job.id,
        details: {
          description: {
            content: job.description,
            editable: true,
          },
          workStatus: job.workStatus,
          needFollowUp: job.isFollowUpAppointmentRequired,
          warrantyStatus: parseWarrantyStatus(job.price.type),
        },
        price: {
          visibleAmountWithoutVat: job.price.priceVATexcl,
          visibleAmountWithVat: job.price.priceVATincl,
          vatRate: isPresent(job.price.taxRate) && job.price.taxRate / 100,
        },
        order: {
          status: job.orderStatus,
          hasSignature: job.hasOrderSignature,
        },
      };
    });
  },
  settings: {
    upsellItems: 'upselling',
    signableDocuments: 'signableDocuments',
    visibleJobIds: (data: any) => data.jobs.map((j: any) => j.id),
    diagnosticTypeDescriptionId: 'complaintStepId',
    keyLabelRequired: 'isMandatoryKeyLabel',
    mileageRequired: 'object.isMandatoryMileage',
    locationRequired: 'object.isMandatoryLocation',
    hasCleaningOption: 'hasCleaningOption',
  },
};

export function parseCheckInDetails(data: any): CheckInDetails | null {
  const details = parseEntity(data, SCHEMA, CheckInDetails);
  details?.jobs.forEach(job => {
    const jobData = data.jobs.find((j: any) => job.id === j.id);
    const complaint = parseComplaintDiagnostic(jobData.diagnosticComplaint);
    job.diagnostics = complaint ? [complaint] : [];
  });
  return details;
}